import { useContext, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Box, Card, CardContent, Typography } from '@mui/material';
import { SyncOutlined } from '@mui/icons-material';
import { UserContext } from '../context/UserContext';
import { toast } from 'react-toastify';

const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { fetchUser } = useContext(UserContext);

  useEffect(() => {
    const handleCallback = () => {
      const params = new URLSearchParams(location.search);
      const token = params.get('token');

      if (token) {
        try {
          localStorage.setItem('authToken', token);
          sessionStorage.removeItem('leadAgentNoticeAccepted');
          fetchUser();
          toast('Logged in successfully!', { type: 'success' });
        } catch (error) {
          navigate('/login');
          toast('Authentication failed.', { type: 'error' });
        }
      } else {
        navigate('/login');
        toast('Authentication failed.', { type: 'error' });
      }
    };

    handleCallback();
  }, [location, navigate, fetchUser]);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        bgcolor: 'background.default',
        p: { xs: 2, sm: 3 },
      }}
    >
      <Card
        sx={{
          maxWidth: 400,
          width: '100%',
          overflow: 'visible',
          position: 'relative',
        }}
      >
        <Box
          sx={{
            position: 'absolute',
            top: { xs: -20, sm: -30 },
            left: '50%',
            transform: 'translateX(-50%)',
            bgcolor: 'primary.main',
            borderRadius: '50%',
            p: { xs: 1.5, sm: 2 },
            boxShadow: '0 4px 12px rgba(63, 81, 181, 0.2)',
          }}
        >
          <SyncOutlined
            sx={{
              color: 'white',
              fontSize: { xs: 28, sm: 36 },
              animation: 'spin 2s linear infinite',
              '@keyframes spin': {
                '0%': {
                  transform: 'rotate(0deg)',
                },
                '100%': {
                  transform: 'rotate(360deg)',
                },
              },
            }}
          />
        </Box>

        <CardContent sx={{ pt: { xs: 4, sm: 6 }, pb: { xs: 2, sm: 3 }, mt: { xs: 2, sm: 3 } }}>
          <Typography
            variant='h4'
            component='h1'
            align='center'
            sx={{
              mb: { xs: 1.5, sm: 2 },
              fontWeight: 600,
              color: 'text.primary',
              fontSize: { xs: '20px', sm: '24px', md: '32px' },
            }}
          >
            Authentication in Progress
          </Typography>

          <Typography 
            variant='body1' 
            align='center' 
            color='text.secondary' 
            sx={{ 
              mb: { xs: 1.5, sm: 2 },
              fontSize: { xs: '14px', sm: '16px' }
            }}
          >
            Please wait while we complete the authentication process
          </Typography>
        </CardContent>
      </Card>
    </Box>
  );
};

export default AuthCallback;
